import React from 'react';
import T from 'components/T';
import { M } from '@dashboard-experience/mastodon';
import { i18n } from '@international/mastodon-i18n';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import securityLogo from '../../images/icons/security.svg';

const SecurityLogo = styled.img`
  height: ${props => props.logoHeight};
  align-self: top;
`;

const SecurityDiv = styled.div`
  display: flex;
  padding-right: 0.25rem;
`;

const MarginBottomH3 = styled.h3`
  margin-bottom: 0;
`;

const SecurityContainer = styled(M.Container)`
  margin-bottom: 0 !important;
`;

const SecurityDetails = styled(M.Container.Row)`
  padding-bottom: 0 !important;
`;

const SecurityContainerRow = styled(M.Container.Row)`
  padding-bottom: 0 !important;
`;

const SecurityCol = styled(M.Container.Col)`
  margin-bottom: 0 !important;
`;

const SecurityNotice = ({ logoHeight, smallerTitle }) => (
  <SecurityContainer type='official'>
    <SecurityContainerRow>
      <SecurityDiv>
        <SecurityLogo
          src={securityLogo}
          alt={i18n.getStr('components.Privacy.SecurityNotice.securityLogo')}
          logoHeight={logoHeight}
        />
      </SecurityDiv>
      <SecurityCol>
        <SecurityDetails>
          {smallerTitle ? (
            <MarginBottomH3>
              <T value='components.Privacy.SecurityNotice.title' />
            </MarginBottomH3>
          ) : (
            <h5>
              <T value='components.Privacy.SecurityNotice.title' />
            </h5>
          )}
          <T
            value='components.Privacy.SecurityNotice.description'
            dangerousHTML
          />
        </SecurityDetails>
      </SecurityCol>
    </SecurityContainerRow>
  </SecurityContainer>
);

SecurityNotice.propTypes = {
  logoHeight: PropTypes.string,
  smallerTitle: PropTypes.bool,
};

SecurityNotice.defaultProps = {
  logoHeight: '86px',
  smallerTitle: false,
};

export default i18n.renderTranslation()(SecurityNotice);
